import React, {Component} from 'react';
import {translate} from 'react-i18next';
import PropTypes from 'prop-types';

class ErrorMessage extends Component {
  render() {
    const {t, onRetry, onReturn, icon, inProgress} = this.props;
    return (
        <div className="error-wrapper">
          <div className="error-message">
            <div className="error-message__image">
              <img src={icon} alt=""/>
            </div>

            <div className="error-message__title">{t('error_hm_long_line')}</div>

            <div className="error-message__text-block">
              <div className="error-message__subtitle">{t('error_reason')}</div>
              <div className="error-message__text">
                {t('error_system_unavailable')}
              </div>
            </div>

            <div className="error-message__text-block">
              <div className="error-message__subtitle">{t('error_suggestion')}</div>
              <div className="error-message__text">
                {t('error_suggestion_action')}
              </div>
            </div>

            <div className="error-message__buttons">
              {onRetry &&
              <button disabled={inProgress} className="error-message__button" onClick={onRetry}>
                {t('error_retry')}
              </button>
              }
              {onReturn &&
              <button disabled={inProgress} className="error-message__button" onClick={onReturn}>
                {t('error_return')}
              </button>
              }
            </div>

          </div>
        </div>
    );
  }
}

ErrorMessage.propTypes = {
  icon: PropTypes.string,
  onReturn: PropTypes.func,
  onRetry: PropTypes.func,
  inProgress: PropTypes.bool
};

export default translate('translations')(ErrorMessage);



// WEBPACK FOOTER //
// ./src/components/Errors/ErrorMessage.js